import { HUB_ENDPOINTS } from '../../../../../utils/endpoints';
import { http_post } from '../../../../../utils/hub_client';
import { setResponseActiveStep } from '../../../../../../../redux/hubSlice';

export const isHubRuntime = () => window.location?.pathname?.split('/')?.[2] === 'hub';

export const getCurrentTime = () => new Date().toISOString();

export const getActiveStepResponse = (responseData, activeStepId) => {
  if (!activeStepId || !Array.isArray(responseData?.response)) return null;
  return responseData.response.find((item) => item?.id === activeStepId) || null;
};

export const getAttemptByLayerId = (responseData, activeStepId, layerId) => {
  const activeStepResponse = getActiveStepResponse(responseData, activeStepId);
  if (!Array.isArray(activeStepResponse?.attempt)) return null;
  return activeStepResponse.attempt.find((item) => item?.id === layerId) || null;
};

export const buildResponsePayload = ({ responseData, activeStepId, attemptDetail }) => {
  const nextResponses = Array.isArray(responseData?.response) ? [...responseData.response] : [];
  const stepIndex = nextResponses.findIndex((item) => item?.id === activeStepId);

  if (stepIndex === -1) {
    nextResponses.push({
      id: activeStepId,
      attempt: [attemptDetail],
      completion: false
    });
  } else {
    const stepRecord = { ...nextResponses[stepIndex] };
    const attempts = Array.isArray(stepRecord?.attempt) ? [...stepRecord.attempt] : [];
    const attemptIndex = attempts.findIndex((item) => item?.id === attemptDetail.id);

    if (attemptIndex === -1) {
      attempts.push(attemptDetail);
    } else {
      attempts[attemptIndex] = {
        ...attempts[attemptIndex],
        ...attemptDetail
      };
    }

    stepRecord.attempt = attempts;
    nextResponses[stepIndex] = stepRecord;
  }

  return {
    minutes: responseData?.minutes || 0,
    response: nextResponses
  };
};

export const saveHubResponse = async ({ materialId, payload, dispatch, responseData }) => {
  const url = HUB_ENDPOINTS.SAVE_RESPONSE(materialId);
  const res = await http_post(url, payload);
  dispatch(
    setResponseActiveStep({
      ...res.data.data,
      completeStatus: responseData?.completeStatus || {}
    })
  );
  return res.data.data;
};
